/**
 * KundenfreigabeStatusBadge — the Tab-4c delivery status chip (P2 Placement Slice 12).
 */

import { Badge } from '../../components/ui/Badge';
import type { CustomerDeliveryStatus } from '@brokly/shared';

export function KundenfreigabeStatusBadge({ status }: { status: CustomerDeliveryStatus | null }) {
  if (status === 'entschieden') {
    return <Badge variant="success" data-testid="kundenfreigabe-status-badge">Entschieden</Badge>;
  }
  if (status === 'zugestellt') {
    return <Badge variant="info" data-testid="kundenfreigabe-status-badge">Beim Kunden</Badge>;
  }
  return <Badge variant="neutral" data-testid="kundenfreigabe-status-badge">Noch nicht zugestellt</Badge>;
}
